







import Vue from "vue"
import CPublicCorporationProfilePage from "~/components/custom/corporationMypage/CPublicCorporationProfilePage.vue"
import { CorporationAccountView } from "~/backendApis/viewModel"
import { BackendApi } from "~/backendApis"

interface DataType {
  corporationAccount: CorporationAccountView | null
}

export default Vue.extend({
  components: {
    CPublicCorporationProfilePage,
  },
  layout: "application",
  validate({ params }) {
    return (
      params.universalCorporationId !== undefined &&
      /^[a-zA-Z0-9]+$/.test(params.universalCorporationId)
    )
  },
  data(): DataType {
    return {
      corporationAccount: null,
    }
  },
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: this.corporationAccount?.name || undefined,
      currentPath: this.$nuxt.$route.path,
    })
  },
  computed: {
    isCorporationMyPage(): boolean {
      return (
        !!this.$clAuth.corporationId &&
        this.$clAuth.corporationId === this.$route.params.universalCorporationId
      )
    },
  },
  watch: {
    // 認証がブラウザ側での画面描画のタイミングで行われる仕様上、その認証処理を待たないと表示しているプロフィール画面がマイページなのかどうかが判定できない。
    // そのため、マイページかどうかの判定を常に監視して、その結果に変更が生じたタイミングでナビゲーションバーの状態も更新するようにしている。
    isCorporationMyPage: {
      handler(isCorporationMyPage) {
        if (isCorporationMyPage) {
          this.$nuxt.$router.push({ path: "/corporation/profile" })
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$clStores.mobileNavigationMenu.actions.changeState({
      pageTitle: "企業詳細",
      isVisibleBottomNav: true,
    })
    this.initializeCorporationAccount()
  },
  methods: {
    async initializeCorporationAccount() {
      const universalCorporationId = this.$route.params.universalCorporationId
      const corporationAccount: CorporationAccountView | null = await BackendApi.general.corporationAccount.read.getCorporationAccount(
        {
          universalCorporationId,
        }
      )
      this.corporationAccount = corporationAccount

      if (!this.corporationAccount) {
        this.$nuxt.error({
          statusCode: 404,
        })
      }
    },
  },
})
